import React from 'react';
import { getYearLabel } from '../../constants/Constants';

const ModerationWindowSelector = ({ value, onChange }) => {
  const yearLabel = getYearLabel();
  return (
    <div className="field mb-5">
      <label className="label has-text-weight-semibold">
        Which moderation window are you requesting a visit for?
      </label>
      <div className="control">
        <label className="radio is-block mb-2">
          <input
            type="radio"
            name="moderationWindow"
            value="window1"
            checked={value === 'window1'}
            onChange={(e) => onChange(e.target.value)}
            className="mr-2"
          />
          Moderation window 1 (February series) – {yearLabel}
        </label>
        <label className="radio is-block" style={{ marginLeft:"-1px"}}>
          <input
            type="radio"
            name="moderationWindow"
            value="window2"
            checked={value === 'window2'}
            onChange={(e) => onChange(e.target.value)}
            className="mr-2"
          />
          Moderation window 2 (June series) – {yearLabel}
        </label>
      </div>
    </div>
  );
};

export default ModerationWindowSelector;